import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "message-notice"
};
var _hoisted_2 = {
  class: "notice-top"
};
var _hoisted_3 = {
  key: 0,
  class: "empty"
};
var _hoisted_4 = {
  key: 0,
  class: "notice-content"
};
var _hoisted_5 = {
  class: "notice-list"
};
var _hoisted_6 = {
  class: "content"
};
import { useRouter } from 'vue-router';
import { getMstListAll, getunReadCount, getBatchUpdate } from '@/api/home.js';
import { filterStr } from '@/util/util.js';
import { validateNull } from '@/util/validate';
import { MessagePlugin } from 'tdesign-vue-next';
import { onMounted, computed, ref, onBeforeUnmount } from 'vue';
import $Bus from '@/util/bus';
import { NOTIFY_UPDATA_EVENT } from '@/const/busEvent.js';
import { getStore } from '@/util/store.js';
export default {
  __name: 'MessageNotice',
  props: {
    single: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var accessToken = getStore({
      name: 'access_token'
    }); // 获取accessToken
    var router = useRouter();
    var isLoading = ref(true);
    var noticeNum = ref(0);
    var noticeList = ref([]);
    var isEmpty = computed(function () {
      return !isLoading.value && validateNull(noticeList.value);
    });
    onMounted(function () {
      initData();
      addBusEvent();
    });
    onBeforeUnmount(function () {
      removeBusEvent();
    });
    /**
     * 添加事件监听
     */
    var addBusEvent = function addBusEvent() {
      $Bus.on(NOTIFY_UPDATA_EVENT, initData);
    };
    /**
     * 移除事件监听
     */
    var removeBusEvent = function removeBusEvent() {
      $Bus.off(NOTIFY_UPDATA_EVENT, initData);
    };
    /**
     * 初始化数据
     */
    var initData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              isLoading.value = true;
              _context.p = 1;
              noticeList.value = [];
              _context.n = 2;
              return noticeCount();
            case 2:
              if (!(noticeNum.value > 0)) {
                _context.n = 3;
                break;
              }
              _context.n = 3;
              return getNoticeContent();
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              (_t === null || _t === void 0 ? void 0 : _t.message) && MessagePlugin.warning(_t === null || _t === void 0 ? void 0 : _t.message);
            case 5:
              _context.p = 5;
              isLoading.value = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[1, 4, 5, 6]]);
      }));
      return function initData() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * 获取未读消息数量
     */
    var noticeCount = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _res$data, code, data, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getunReadCount();
            case 1:
              res = _context2.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                noticeNum.value = data || 0;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) && MessagePlugin.warning(_t2 === null || _t2 === void 0 ? void 0 : _t2.message);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function noticeCount() {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * 获取未读消息列表
     */
    var getNoticeContent = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res, _res$data2, code, data, records, tempList, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                current: 1,
                size: 2
              };
              _context3.n = 1;
              return getMstListAll(params);
            case 1:
              res = _context3.v;
              _res$data2 = res.data, code = _res$data2.code, data = _res$data2.data;
              if (code === 0 && data) {
                records = data.records;
                if (!validateNull(records)) {
                  tempList = props.single ? [records[0]] : records.splice(0, 2);
                  noticeList.value = tempList.map(function (item) {
                    var payload = item.payload,
                      id = item.id;
                    return {
                      id: id,
                      content: filterStr((payload === null || payload === void 0 ? void 0 : payload.content) || (payload === null || payload === void 0 ? void 0 : payload.title) || '')
                    };
                  });
                }
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              (_t3 === null || _t3 === void 0 ? void 0 : _t3.message) && MessagePlugin.warning(_t3 === null || _t3 === void 0 ? void 0 : _t3.message);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      return function getNoticeContent() {
        return _ref3.apply(this, arguments);
      };
    }();
    /**
     * 查看消息列表
     */
    var handleGoNotice = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, code;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return getBatchUpdate();
            case 1:
              res = _context4.v;
              code = res.data.code;
              if (code === 0) {
                router.push('/notice');
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function handleGoNotice() {
        return _ref4.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "title"
      }, "消息", -1)), _createElementVNode("div", {
        class: "right-box",
        onClick: handleGoNotice
      }, [_withDirectives(_createElementVNode("span", {
        class: "num"
      }, _toDisplayString(noticeNum.value), 513), [[_vShow, noticeNum.value > 0]]), isEmpty.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, "暂无消息")) : _createCommentVNode("", true), _createVNode(_component_svg_icon, {
        name: "arrow-right-not"
      })])]), noticeList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "notice-item"
        }, [_createElementVNode("p", _hoisted_6, _toDisplayString(item.content), 1)]);
      }), 128))])])) : _createCommentVNode("", true)]);
    };
  }
};